import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { OutlineRedirect } from './OutlineRedirect';

export interface KnowledgeBaseRoutingProps extends RouteComponentProps {}

export const KnowledgeBaseRouting = (props: KnowledgeBaseRoutingProps) => {
  return (
    <Switch>
      <Route path={`${props.match.path}/outline-redirect`} component={OutlineRedirect} exact />
    </Switch>
  );
};
